import CardLayoutDefault from "@comparaonline/ui-offer-card-layout";
import CardLayoutExtended from "@comparaonline/ui-offer-card-layout-extended";
import CardLayoutMobile from "@comparaonline/ui-offer-card-layout-mobile";
import { SkeletonCard } from "@comparaonline/ui-offer-card-skeleton/dist/Default";
import { SkeletonCardExtended } from "@comparaonline/ui-offer-card-skeleton/dist/Extended";
import { SkeletonCardMobile } from "@comparaonline/ui-offer-card-skeleton/dist/Mobile";

import { useAppContext } from "../../../../../lib/appContext";
import { Orientation } from "./constants";
import { useCardOrientation } from "./useCardOrientation";

interface CardLayout {
  Layout: React.ComponentType;
  Placeholder: React.ComponentType;
}

const useCardLayout = (): CardLayout => {
  const { isMobile } = useAppContext();
  const cardOrientation = useCardOrientation();

  if (isMobile) {
    return {
      Layout: CardLayoutMobile,
      Placeholder: SkeletonCardMobile
    };
  }

  return cardOrientation === Orientation.Horizontal
    ? {
        Layout: CardLayoutExtended,
        Placeholder: SkeletonCardExtended
      }
    : {
        Layout: CardLayoutDefault,
        Placeholder: SkeletonCard
      };
};

export { useCardLayout };
